module.exports = __webpack_public_path__ + "media/images/subject_img/BIOCHEMISTRY-b6f243b16b9a4d974619c8d31b5b6c92.jpg";